module.exports = __webpack_public_path__ + "img/n-h-page3-2.5443d454.png";